export default {
   setLogInfo(state, res) {
      localStorage.setItem('jyb_token', res.token);
      localStorage.setItem('jyb_logInfo', JSON.stringify(res.data));
      state.logInfo = res.data;
      state.token = res.token;
   },
   cleatLogInfo(state, value) {
      localStorage.removeItem('jyb_token');
      localStorage.removeItem('jyb_logInfo');
      state.logInfo = {};
      state.token = '';
   },
   setKeyWord(state, value) {
      state.keyword = value;
   }
};